<template>
  <v-card
    color="grey lighten-4"
    light
  >
    <v-card-text>
      <content-section title="Who am I?">
        {{
          language !== 'en'
            ? '다양한 분야를 즐기는 커뮤니케이션이 즐거운 개발자입니다.'
            : 'A developer who enjoys communication and enjoys various fields'
        }}
      </content-section>
      <content-section
        v-if="careers"
        title="Career"
      >
        <v-layout
          v-for="(career, i) in language !== 'en' ? careers : careers_en"
          :key="i"
        >
          <v-flex md4>
            {{ career.from }} - {{ career.to }}
          </v-flex>
          <v-flex
            md8
            class="align-start align-self-start"
          >
            <strong v-if="career.title">{{ career.title }}</strong>
            {{ `${career.location ? '/' : ''}${career.location}` }}
          </v-flex>
        </v-layout>
      </content-section>
      <content-section
        v-if="educations"
        title="Education"
      >
        <v-layout
          v-for="(education, i) in language !== 'en' ? educations : educations_en"
          :key="i"
        >
          <v-flex md4>
            {{ education.from }} - {{ education.to }}
          </v-flex>
          <v-flex md8>
            <strong v-if="education.title">{{ education.title }}</strong>
            <div v-if="education.location">
              <i>{{ education.location }}</i>
            </div>
            <div v-if="education.description">
              {{ education.description }}
            </div>
          </v-flex>
        </v-layout>
      </content-section>
      <content-section
        v-if="skills"
        title="Skills"
      >
        <template slot="actions">
          <!-- (% are relative not absolute) -->
        </template>
        <v-layout wrap>
          <template v-for="(skill, i) in skills">
            <v-flex
              v-if="skill.divider"
              :key="i"
              md12
              xs12
              mb-4
            />
            <v-flex
              v-else
              :key="i"
              md6
              xs12
            >
              <div class="mr-2 ml-2">
                <div class="align-center">
                  <v-icon small>
                    {{ skill.icon }}
                  </v-icon>
                  {{ skill.title }}
                </div>
                <v-progress-linear
                  class="progress"
                  color="secondary"
                  height="3"
                  :value="skill.value"
                />
              </div>
            </v-flex>
          </template>
        </v-layout>
      </content-section>
    </v-card-text>
  </v-card>
</template>

<script>
import ContentSection from '@/views/dark-template/content/Section'
export default {
  name      : 'MainContent',
  components: { ContentSection },
  data      : () => ({
    educations: [
      {
        from    : '2006',
        to      : '2014',
        title   : '숭실대학교 산업정보시스템공학과',
        location: '',
      },
      {
        from    : '2012',
        to      : '2014',
        title   : '삼성 소프트웨어멤버십',
        location: ' ',
      },
    ],
    educations_en: [
      {
        from    : '2006',
        to      : '2014',
        title   : 'Industrial and Information Systems Engineering, Soongsil University',
        location: '',
      },
      {
        from    : '2012',
        to      : '2014',
        title   : 'Samsung Software Membership',
        location: ' ',
      },
    ],
    careers: [
      {
        from    : '2017',
        to      : '현재',
        title   : '카카오',
        location: '',
      },
      {
        from    : '2023',
        to      : '현재',
        title   : '카카오',
        location: '광고 공통 개발',
      },
      {
        from    : '2017',
        to      : '2023',
        title   : '카카오',
        location: '동영상 개발 파트',
      },
      {
        from    : '2014',
        to      : '2017',
        title   : '삼성 테크윈',
        location: 'WEB SW 개발팀, 선행개발팀',
      },
      {
        from    : '2007',
        to      : '2010',
        title   : '미디어솔루션',
        location: 'SW 프로젝트 개발팀',
      },
    ],
    careers_en: [
      {
        from    : '2017',
        to      : 'Current',
        title   : 'Kakao',
        location: 'Video Client',
      },
      {
        from    : '2014',
        to      : '2017',
        title   : 'Samsung Techwin',
        location: 'Web Software Development',
      },
      {
        from    : '2007',
        to      : '2010',
        title   : 'Media Solution',
        location: 'Software Project Development',
      },
    ],
    skills: [
      {
        title: 'JavaScript',
        icon : 'mdi-language-javascript',
        value: 90,
      },
      {
        title: 'Vue.js Framework',
        icon : 'mdi-vuejs',
        value: 70,
      },
      {
        title: 'Vite',
        icon : 'mdi-vuejs',
        value: 50,
      },
      {
        title: 'React Framework',
        icon : 'mdi-react',
        value: 90,
      },
      {
        title: 'HTML',
        icon : 'mdi-language-html5',
        value: 90,
      },
      {
        title: 'CSS',
        icon : 'mdi-language-css3',
        value: 80,
      },
      {
        title: 'TailwindCSS',
        icon : 'mdi-waves',
        value: 60,
      },
      {
        title: 'NextJS',
        icon : 'mdi-react',
        value: 70,
      },
      { divider: true },
      {
        title: 'Docker',
        icon : 'mdi-docker',
        value: 40,
      },
      {
        title: 'Nginx',
        icon : 'mdi-web',
        value: 30,
      },
      {
        title: 'Firebase',
        icon : 'mdi-mdi-google',
        value: 70,
      },
      {
        title: 'CI / CD',
        icon : 'mdi-truck-fast',
        value: 35,
      },
      {
        title: 'Git',
        icon : 'mdi-git',
        value: 70,
      },
      {
        title: 'Supabase',
        icon : 'mdi-database',
        value: 40,
      },
      {
        title: 'Jira',
        icon : 'mdi-jira',
        value: 70,
      },
      {
        title: 'Slack',
        icon : 'mdi-slack',
        value: 50,
      },
      { divider: true },
      {
        title: 'Video/Audio',
        icon : 'mdi-file-video',
        value: 60,
      },
      {
        title: 'AWS',
        icon : 'mdi-aws',
        value: 50,
      },
      {
        title: 'Claude code',
        icon : 'mdi-robot',
        value: 50,
      },
      {
        title: 'Cursor',
        icon : 'mdi-robot',
        value: 70,
      },
      {
        title: 'ad',
        icon : 'mdi-youtube-tv',
        value: 40,
      },
    ],
  }),
  computed: {
    language () {
      return this.$route.params.lang
    },
  },
}
</script>

<style scoped>
  .title {
    border-bottom: 2px #bfbfbf solid;
    line-height: 1.5 !important;
  }
  .progress {
    margin-top: 0.1rem;
  }
</style>
